import { useCallback } from "react";

function VoiceCallAudio({ stream }) {
  const refLocalAudio = useCallback(
    (node) => {
      if (node === null) return;

      node.srcObject = stream;
    },
    [stream]
  );

  return <audio autoPlay={true} ref={refLocalAudio}></audio>;
}

export default VoiceCallAudio;
